import { createContext, useContext, useReducer, useState } from 'react';
import {
  defaultChecker,
  emailChecker,
  PasswordChecker,
  confirmPassWord,
} from './formFieldChecker';
export const FormDataContext = createContext();
const initialState = { val: '', error: '' };

//----------------------**************************--------------------
const loginEmailReducer = (previousVal, action) => {
  return emailChecker(action, previousVal);
};
const loginPasswordReducer = (previousVal, action) => {
  return defaultChecker(action, previousVal);
};

//----------------------**************************--------------------
const signUpEmailReducer = (previousVal, action) => {
  return emailChecker(action, previousVal);
};
const signUpnameReducer = (previousVal, action) => {
  return defaultChecker(action, previousVal);
};
const signUpPasswordReducer = (previousVal, action) => {
  return PasswordChecker(action, previousVal);
};
const signUpConfirmPasswordReducer = (previousVal, action) => {
  return confirmPassWord(action, previousVal);
};

// ----------------------**************************--------------------

const addMunDescriptionReducer = (previousVal, action) => {
  return defaultChecker(action, previousVal);
};

const addMunDateReducer = (previousVal, action) => {
  return defaultChecker(action, previousVal);
};

const addMunTimeReducer = (previousVal, action) => {
  return defaultChecker(action, previousVal);
};

const addMunlocationReducer = (previousVal, action) => {
  return defaultChecker(action, previousVal);
};

const addMunCityReducer = (previousVal, action) => {
  return defaultChecker(action, previousVal);
};

const addMunVacancyReducer = (previousVal, action) => {
  return defaultChecker(action, previousVal);
};

const addMunPriceReducer = (previousVal, action) => {
  return defaultChecker(action, previousVal);
};

const addMunPackageReducer = (previousVal, action) => {
  return defaultChecker(action, previousVal);
};

const addMunApplicationDateReducer = (previousVal, action) => {
  return defaultChecker(action, previousVal);
};

// ----------------------**************************--------------------

// ----------------------**************************--------------------

const profileBoxnameReducer = (previousVal, action) => {
  return defaultChecker(action, previousVal);
};

const profileBoxemailReducer = (previousVal, action) => {
  return emailChecker(action, previousVal);
};

// ----------------------**************************--------------------

//----------------------**************************--------------------
const resetPasswordEmailReducer = (previousVal, action) => {
  return emailChecker(action, previousVal);
};
const resetPasswordOTPReducer = (previousVal, action) => {
  return defaultChecker(action, previousVal);
};

//----------------------**************************--------------------
const resetnewPasswordReducer = (previousVal, action) => {
  return PasswordChecker(action, previousVal);
};
const resetnewConfirmPasswordReducer = (previousVal, action) => {
  return confirmPassWord(action, previousVal);
};

const FormContext = (Props) => {
  const [loginEmail, dispatchLoginEmail] = useReducer(
    loginEmailReducer,
    initialState
  );
  const [loginPassword, dispatchLoginPassword] = useReducer(
    loginPasswordReducer,
    initialState
  );

  const [signUpname, dispatchsignUpname] = useReducer(
    signUpnameReducer,
    initialState
  );
  const [signUpEmail, dispatchsignUpEmail] = useReducer(
    signUpEmailReducer,
    initialState
  );
  const [signUpPassword, dispatchsignUpPassword] = useReducer(
    signUpPasswordReducer,
    initialState
  );
  const [signUpConfirmPassword, dispatchsignUpConfirmPassword] = useReducer(
    signUpConfirmPasswordReducer,
    initialState
  );

  // for mun---------------

  const [munDescription, dispatchMunDescription] = useReducer(
    addMunDescriptionReducer,
    initialState
  );

  const [munDate, dispatchMunDate] = useReducer(
    addMunDateReducer,
    initialState
  );

  const [munTime, dispatchMunTime] = useReducer(
    addMunTimeReducer,
    initialState
  );

  const [munLocation, dispatchMunLocation] = useReducer(
    addMunlocationReducer,
    initialState
  );

  const [munCity, dispatchMunCity] = useReducer(
    addMunCityReducer,
    initialState
  );

  const [munVacancy, dispatchMunVacancy] = useReducer(
    addMunVacancyReducer,
    initialState
  );

  const [munPrice, dispatchMunPrice] = useReducer(
    addMunPriceReducer,
    initialState
  );

  const [munPackage, dispatchMunPackage] = useReducer(
    addMunPackageReducer,
    initialState
  );

  const [munApplicationDate, dispatchMunApplicationDate] = useReducer(
    addMunApplicationDateReducer,
    initialState
  );

  // --------------------

  // for profilebox ----------------

  const [profilename, dispatchProfilename] = useReducer(
    profileBoxnameReducer,
    initialState
  );

  const [profileemail, dispatchProfileemail] = useReducer(
    profileBoxemailReducer,
    initialState
  );

  // -------------

  const [termsAndCondition, toggleTermsAndCondition] = useState(false);

  const [resetPasswordEmail, dispatchresetPasswordEmail] = useReducer(
    resetPasswordEmailReducer,
    initialState
  );
  const [resetPasswordOTP, dispatchresetPasswordOTP] = useReducer(
    resetPasswordOTPReducer,
    initialState
  );
  const [resetnewPassword, dispatchresetnewPassword] = useReducer(
    resetnewPasswordReducer,
    initialState
  );
  const [resetnewConfirmPassword, dispatchresetnewConfirmPassword] = useReducer(
    resetnewConfirmPasswordReducer,
    initialState
  );

  const Context = {
    login: {
      email: {
        value: loginEmail,
        changeTo: (text) => {
          dispatchLoginEmail({ type: 'changeTo', val: text });
        },
        checkError: (text) => {
          dispatchLoginEmail({ type: 'checkError', val: text });
        },
        addError: (err) => {
          dispatchLoginEmail({ type: 'addError', err: err });
        },
      },
      password: {
        value: loginPassword,
        changeTo: (text) => {
          dispatchLoginPassword({ type: 'changeTo', val: text });
        },
        addError: (err) => {
          dispatchLoginPassword({ type: 'addError', err: err });
        },
      },
    },
    signUp: {
      username: {
        value: signUpname,
        changeTo: (text) => {
          dispatchsignUpname({ type: 'changeTo', val: text });
        },
        addError: (err) => {
          dispatchsignUpname({ type: 'addError', err: err });
        },
      },
      email: {
        value: signUpEmail,
        changeTo: (text) => {
          dispatchsignUpEmail({ type: 'changeTo', val: text });
        },
        checkError: (text) => {
          dispatchsignUpEmail({ type: 'checkError', val: text });
        },
        addError: (err) => {
          dispatchsignUpEmail({ type: 'addError', err: err });
        },
      },
      password: {
        value: signUpPassword,
        changeTo: (text) => {
          dispatchsignUpPassword({ type: 'changeTo', val: text });
        },
        checkError: (text) => {
          dispatchsignUpPassword({ type: 'checkError', val: text });
        },
        addError: (err) => {
          dispatchsignUpPassword({ type: 'addError', err: err });
        },
      },
      confirm: {
        value: signUpConfirmPassword,
        changeTo: (text) => {
          dispatchsignUpConfirmPassword({ type: 'changeTo', val: text });
        },
        checkError: (text) => {
          dispatchsignUpConfirmPassword({
            type: 'checkError',
            val: text,
            passVal: signUpPassword,
          });
        },
        addError: (err) => {
          dispatchsignUpConfirmPassword({ type: 'addError', err: err });
        },
      },
      termsAndCondition: {
        value: termsAndCondition,
        changeTo: () => {
          toggleTermsAndCondition(!termsAndCondition);
        },
      },
    },
    profile: {
      name: {
        value: profilename,
        changeTo: (text) => {
          dispatchProfilename({ type: 'changeTo', val: text });
        },
        addError: (err) => {
          dispatchProfilename({ type: 'addError', err: err });
        },
      },
      email: {
        value: profileemail,
        changeTo: (text) => {
          dispatchProfileemail({ type: 'changeTo', val: text });
        },
        checkError: (text) => {
          dispatchProfileemail({ type: 'checkError', val: text });
        },
        addError: (err) => {
          dispatchProfileemail({ type: 'addError', err: err });
        },
      },
    },
    addMun: {
      description: {
        value: munDescription,
        changeTo: (text) => {
          dispatchMunDescription({ type: 'changeTo', val: text });
        },
        addError: (err) => {
          dispatchMunDescription({ type: 'addError', err: err });
        },
      },
      date: {
        value: munDate,
        changeTo: (text) => {
          dispatchMunDate({ type: 'changeTo', val: text });
        },
        addError: (err) => {
          dispatchMunDate({ type: 'addError', err: err });
        },
      },
      time: {
        value: munTime,
        changeTo: (text) => {
          dispatchMunTime({ type: 'changeTo', val: text });
        },
        addError: (err) => {
          dispatchMunTime({ type: 'addError', err: err });
        },
      },
      location: {
        value: munLocation,
        changeTo: (text) => {
          dispatchMunLocation({ type: 'changeTo', val: text });
        },
        addError: (err) => {
          dispatchMunLocation({ type: 'addError', err: err });
        },
      },

      city: {
        value: munCity,
        changeTo: (text) => {
          dispatchMunCity({ type: 'changeTo', val: text });
        },
        addError: (err) => {
          dispatchMunCity({ type: 'addError', err: err });
        },
      },
      vacancy: {
        value: munVacancy,
        changeTo: (text) => {
          dispatchMunVacancy({ type: 'changeTo', val: text });
        },
        addError: (err) => {
          dispatchMunVacancy({ type: 'addError', err: err });
        },
      },
      price: {
        value: munPrice,
        changeTo: (text) => {
          dispatchMunPrice({ type: 'changeTo', val: text });
        },
        addError: (err) => {
          dispatchMunPrice({ type: 'addError', err: err });
        },
      },
      package: {
        value: munPackage,
        changeTo: (text) => {
          dispatchMunPackage({ type: 'changeTo', val: text });
        },
        addError: (err) => {
          dispatchMunPackage({ type: 'addError', err: err });
        },
      },
      applicationDate: {
        value: munApplicationDate,
        changeTo: (text) => {
          dispatchMunApplicationDate({ type: 'changeTo', val: text });
        },
        addError: (err) => {
          dispatchMunApplicationDate({ type: 'addError', err: err });
        },
      },
    },

    resetPassword: {
      email: {
        value: resetPasswordEmail,
        changeTo: (text) => {
          dispatchresetPasswordEmail({ type: 'changeTo', val: text });
        },
        checkError: (text) => {
          dispatchresetPasswordEmail({ type: 'checkError', val: text });
        },
        addError: (err) => {
          dispatchresetPasswordEmail({ type: 'addError', err: err });
        },
      },
      OTP: {
        value: resetPasswordOTP,
        changeTo: (text) => {
          dispatchresetPasswordOTP({ type: 'changeTo', val: text });
        },
        addError: (err) => {
          dispatchresetPasswordOTP({ type: 'addError', err: err });
        },
      },
      password: {
        value: resetnewPassword,
        changeTo: (text) => {
          dispatchresetnewPassword({ type: 'changeTo', val: text });
        },
        checkError: (text) => {
          dispatchresetnewPassword({ type: 'checkError', val: text });
        },
        addError: (err) => {
          dispatchresetnewPassword({ type: 'addError', err: err });
        },
      },
      confirm: {
        value: resetnewConfirmPassword,
        changeTo: (text) => {
          dispatchresetnewConfirmPassword({ type: 'changeTo', val: text });
        },
        checkError: (text) => {
          dispatchresetnewConfirmPassword({
            type: 'checkError',
            val: text,
            passVal: signUpPassword,
          });
        },
        addError: (err) => {
          dispatchresetnewConfirmPassword({ type: 'addError', err: err });
        },
      },
    },
  };
  return (
    <FormDataContext.Provider value={Context}>
      {Props.children}
    </FormDataContext.Provider>
  );
};
export default FormContext;
